import React, { Suspense, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CDN_ORACLE_URL } from "../../config";
import PhoneIcon from "@mui/icons-material/Phone";
import {
  CashDrawerIcon,
  MenuBurgerIcon,
  NotificationBellIcon,
} from "../../assets/icons";
import { useNavigate } from "react-router-dom";
import { isOrderingLicense, resetSaleData } from "helper/saleHelpers";
import { GlobalHotKeys } from "react-hotkeys";
import { Handlers } from "../../types";
import { updateCurrentShortcut } from "redux-store/slices/KeyBoardShortcuts";
import { getGlobalKeyMap, checkCtrlSpace, checkAltNum, checkCtrlShiftSpace, checkAltLetter, checkShiftPlusMinus, checkSpace, checkSlash, checkControlShiftN } from "utils/shortcuts";
import { useSelector, useDispatch } from "react-redux";
import { resetCurrentShortcut } from "redux-store/slices/KeyBoardShortcuts";
import { ROUTE_CONSTANTS_MAP } from "utils/routeConstants";
import { useOnlineStatus } from "hooks/useOnlineStatus";
import { stopDesktopNotification } from "helper/myOrderHelpers";
import {isSlave } from "helper/localServer";
import {getAllOtherNotifications, clearAllNotifications, getAllNewOnlineOrders} from "redux-store/slices/NotificationsSlice";
import { setLoader } from "redux-store/slices/GlobalSlice";
import { CONTROL_SHIFT_N } from "utils/keyboardKeysConstants";
import ChatbotEmbed from "components/Chatbot/chat-modal";
import CommonChip from "commonComponents/CommonChip";
import useSalesFlow from "hooks/useSalesFlow";
import { lazyWithHandler } from "commonComponents/LazyLoadWrapper";
import { openCashDrawer } from "helper/printHelper";
import { ToastNotifySuccess } from "commonComponents/ToastNotify";
import { USBPrinter } from "utils/localStorage";
import { featureRestrictions } from "helper/featureRestrictionHelper";
import CashDrawerModal from "./cashDrawerModal";
import { set } from "lodash";
import { CASH_DRAWER_ACCESS } from "utils/restrictionConstants";
import { verifyPinRequest } from "redux-store/slices/LoginSlice";
import { handleWarningModal, isSupportLogin } from "helper/commonHelpers";
import { DEFAULT_PRINTER_MSG } from "data/constants";
import EnvBadge from "commonComponents/EnvBadge";

const LeftMenu = lazyWithHandler(() => import("../LeftMenu"));
const HoldOrderPopup = lazyWithHandler(() => import("components/HoldOrderPopup"));
const AccountControl = lazyWithHandler(() => import("components/AccountControl"));
const SupportControl = lazyWithHandler(() => import("components/SupportControl"));
const OfflineOnlineToggle = lazyWithHandler(() => import("commonComponents/OfflineOnlineToggle"));
interface Props {
  toggleNotificationsModal : any;
  openItemStockStatus: any;
  isMenuOpen: any;
  setisMenuOpen: any;
  setNotificationNumber: any;
  unReadNotifications :number;
  setShowChatSupportIcon?: (val : boolean) => void;
  showChatSupport?: boolean
}

interface StateProps {
  businessStore: {
    userData: {
      name: {
        firstName: string;
        lastName: string;
      };
      assignedLicence: string;
    };
  };
  toggleNotificationsModal : any
}

const Header: React.FC<Props> = ({ toggleNotificationsModal, openItemStockStatus, isMenuOpen , setisMenuOpen , unReadNotifications, setNotificationNumber, setShowChatSupportIcon, showChatSupport=false }) => {
  const { pathname } = useLocation();
  const [showHoldOrder, setShowHoldOrder] = useState<boolean>(false);
  const currentPath = pathname;
  const navigateTo = useNavigate();
  const dispatch = useDispatch(),
    isOffline = useSelector((state: any) => state.businessStore.isOffline),
    isOnline = useOnlineStatus();
  const userData = useSelector(
    (reducerState: StateProps) => reducerState.businessStore.userData
  );

  const [showAccountControl, setShowAccountControl] = useState<boolean>(false);
  const [requestFromHeader, setRequestFromHeader] = useState<boolean>(false);
  const [showSupportControl, setShowSupportControl] = useState<boolean>(false);
  const shortcutBtn = useSelector((state: any) => state.keyboardShortcutStore?.currentShortcutPressed);
  const openAccountModal = useSelector((state: any) => state.loginStore.openAccountControlModal),
    allNewOnlineOrders = useSelector((state: any) => state.notificationsStore.allNewOnlineOrders);
    const branchData = useSelector((state : any) => state.OutletStatusStore?.branchData);
  const {isOrderFlowPath, hasOrderFlowLicense} = useSalesFlow();
  const showCashDrawer = featureRestrictions(CASH_DRAWER_ACCESS) && isOrderFlowPath && hasOrderFlowLicense && !isOffline && !isSupportLogin();
  const [openModal, setOpenModal] = useState(false);
  /**
   * keyboard shortcuts handling starts here
   */
  const nextTabsMapping: any = {
    [ROUTE_CONSTANTS_MAP.MY_ORDER_ROUTE]: ROUTE_CONSTANTS_MAP.NEW_ORDER_ROUTE,
    [ROUTE_CONSTANTS_MAP.NEW_ORDER_ROUTE]: ROUTE_CONSTANTS_MAP.TABLE_VIEW_ROUTE,
    [ROUTE_CONSTANTS_MAP.TABLE_VIEW_ROUTE]: ROUTE_CONSTANTS_MAP.RESERVATIONS_ROUTE,
    [ROUTE_CONSTANTS_MAP.RESERVATIONS_ROUTE]: ROUTE_CONSTANTS_MAP.MY_ORDER_ROUTE,
  };

  useEffect(() => {
    if (openAccountModal) {
      setShowAccountControl(true);
    }
  }, [openAccountModal]);

  useEffect(() => {
    if (shortcutBtn === "Control+h" || shortcutBtn === "Control+H") {
      setShowSupportControl(!showSupportControl);
      dispatch(resetCurrentShortcut());
    }
    if (shortcutBtn === CONTROL_SHIFT_N) {
      openNotifications();
    }
  }, [shortcutBtn])

  const getUnreadNotificationNumber = () => {
    return (allNewOnlineOrders?.length || 0) + Math.min(unReadNotifications, 20);
  }

  const switchTabs = () => {
    let nextPath = nextTabsMapping[currentPath];
    handleNavigate(nextPath);
  };

  const dispatchUpdateShortcut = (val: string) => {
    console.log("dispatchUpdateShortcut!!!: ", val);
    dispatch(updateCurrentShortcut(val));
  };

  const handler = (e: KeyboardEvent) => {
    if (checkCtrlSpace(e, "handler")) {
      dispatchUpdateShortcut("Control+Space");
    }
    if (checkAltNum(e)) {
      dispatchUpdateShortcut(`Alt+${e.code}`);
    }
    if (checkCtrlShiftSpace(e)) {
      dispatchUpdateShortcut(`Control+Shift+Space`);
    }
    if (checkAltLetter(e)) {
      dispatchUpdateShortcut(`Alt+${e.code}`);
    }
    if (checkShiftPlusMinus(e)) {
      dispatchUpdateShortcut(`Shift${e.key}`);
    }
    if (checkSpace(e)) {
      dispatchUpdateShortcut(`Space`);
    }
    if (checkSlash(e)) {
      dispatchUpdateShortcut(`/`);
    }
    if (checkControlShiftN(e)) {
      dispatchUpdateShortcut(CONTROL_SHIFT_N);
    }
  };

  const ignore = (e: KeyboardEvent) => {
    if (
      checkCtrlSpace(e, "ignore") ||
      checkAltNum(e) ||
      checkCtrlShiftSpace(e) ||
      checkShiftPlusMinus(e) ||
      checkSpace(e) ||
      checkControlShiftN(e)
    ) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    window.addEventListener("keyup", handler);
    window.addEventListener("keydown", ignore);

    return () => {
      window.removeEventListener("keyup", handler);
      window.removeEventListener("keydown", ignore);
    };
  }, []);

  const preventDefaultHandlers = (handlers: Handlers) => {
    const newHandlers: any = {};
    for (const [action, handler] of Object.entries(handlers)) {
      newHandlers[action] = (event: any) => {
        let localMap: any = getGlobalKeyMap();
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        if (localMap[action] !== "SWITCH_TABS") {
          handler(localMap[action]);
        } else {
          handler();
        }
      };
    }
    console.log("newHandlers: ", newHandlers);
    return newHandlers;
  };

  const keyMap: any = getGlobalKeyMap();

  const getHandlersMap = () => {
    let localkeyMap = getGlobalKeyMap(),
      localkeyMapKeys = Object.keys(localkeyMap);
    const obj = {
      ...Object.fromEntries(
        localkeyMapKeys.map(key => [key, dispatchUpdateShortcut])
      )
    };
    obj["SWITCH_TABS"] = switchTabs;
    return obj;
  }

  const handlers: Handlers = preventDefaultHandlers(getHandlersMap());

  /**
   * keyboard shortcuts handling ends here
   */

  const toggleMenuClick = () => {
    setisMenuOpen(!isMenuOpen)
  }

  function toggleHoldOrderPopup() {
    setShowChatSupportIcon?.(!showChatSupport);
    setShowHoldOrder(!showHoldOrder);
  }

  function handleNavigate(path: string) {
    console.log("======opt inside navigate")
    navigateTo(path);
    if (currentPath !== path) {
      resetSaleData();
    }
    console.log("======opt navigate complete")
  }

  function handlePropmt(showAccountModal = true) {
    setShowAccountControl(showAccountModal);
    setRequestFromHeader(showAccountModal)
  }

  function renderAccountandSupport() {
    return (
      <>
        <div title="Request callback"
          className={`flex items-center support-cnt pt-3 pb-3 px-2 lg:pt-17 lg:pb-17 lg:px-18 md:px-12 border-solid border-grey7e84a3op21 cursor-pointer border-l hover:bg-[#EBECF1] ${isOffline ? "border-[#C3C3C3]" : ""}`}
          onClick={() => {setShowSupportControl(!showSupportControl); setShowChatSupportIcon?.(false)}}
        >
          <PhoneIcon
            sx={{
              fontSize: "24px",
            }}
          />
        </div>
        <div title="User Profile"
          className={`flex border-l items-center user-info-cnt pt-1 pl-2 pr-2 pb-1 lg:pt-6 lg:pl-18 lg:pr-18 lg:pb-4 border-solid border-grey7e84a3op21 hover:bg-[#E4E5EC] cursor-pointer ${isOffline ? "border-[#C3C3C3]" : ""}`}
          onClick={() => {
            setShowAccountControl(!showAccountControl);
            setShowChatSupportIcon?.(false);
          }}
        >
          <div className="user-icon-cnt rounded-full min-w-[31px] h-[31px] leading-[31px] text-center bg-grey7c7e8b">
            <span className="font-inter font-normal text-14 text-white capitalize">
              {[
                userData.name?.firstName?.[0],
                userData.name?.lastName?.[0],
              ].join("")}
            </span>
          </div>
        </div>
      </>
    );
  }

  const openNotifications = () => {
    setShowChatSupportIcon?.(false);
    dispatch(setLoader(true));
    toggleNotificationsModal({ show: true, openForAll: true })
    dispatch(clearAllNotifications());
    dispatch(getAllOtherNotifications({ pageSize: 20 }));
    if(!isOrderingLicense())
      dispatch(getAllNewOnlineOrders({}));
  };
 const printer = useSelector((state: any) => state.printerStore?.defaultPrinter);
 const handleDrawerClick =()=>{
   if (printer && !Object.keys(printer)?.length) {
        handleWarningModal(DEFAULT_PRINTER_MSG);
        setOpenModal(false);
        return;
      }
      setOpenModal(true);
 }
 return (
    <>
      <GlobalHotKeys keyMap={keyMap} handlers={handlers} />
      <header
        className={`flex justify-between ${isOffline ? "bg-[#868CA3]" : "bg-white"
          } border-b h-58`}
      >
        <div className={`flex items-center`}>
          <div className="flex w-[60px] h-[58px] items-center justify-center hover:bg-[#EBECF1] cursor-pointer" onClick={toggleMenuClick}>
            <MenuBurgerIcon />
          </div>
          <a className="inline-block pt-18 pb-18 pl-10 min-w-72">
            <img src={`${CDN_ORACLE_URL}/rista_logo_black.svg`} className="h-18" />
          </a>
          <EnvBadge />
        </div>
        {
          isOrderFlowPath && hasOrderFlowLicense &&
            <RenderRoutes handleNavigate={handleNavigate}/>
        }
        <div className="flex space-x-2 min-w-0 overflow-x-auto sm:overflow-x-visible">
          <ChatbotEmbed chatbotId={process.env.REACT_APP_CHATBOT_ID || ""} />
          {(!isOnline || isOffline) && (
            <div
              className={`flex justify-end items-center ${isOffline ? "mr-5" : ""
                }`}
            >
              <Suspense fallback={<div>Loading...</div>}>
                <OfflineOnlineToggle showUserPropmt = {() => handlePropmt()}/>
              </Suspense>
            </div>
          )}
            <>
           {showCashDrawer &&
             <button
               className={`text-18 border-l flex h-[58px] items-center justify-center hover:bg-[#EBECF1] cursor-pointer px-2 lg:px-0 lg:w-[68px] md:w-[52px]`}
               onClick ={() => {
                 {handleDrawerClick()}
               }
              }
             >
                <CashDrawerIcon bgcolor="black" width="25" height="25"/>
             </button>
           }
           <CashDrawerModal
             open={openModal}
             onClose={() => setOpenModal(false)}
             onSubmit={(data:any) => {
              {{openCashDrawer(printer)}
             {ToastNotifySuccess("Cash drawer is open")}}
             }}
           />
              {
                isOrderFlowPath && hasOrderFlowLicense &&
                <div title="Orders On Hold"
                  className="text-18 border-l flex h-[58px] items-center justify-center hover:bg-[#EBECF1] cursor-pointer px-2 lg:px-0 lg:w-[68px] md:w-[52px]"
                  onClick={toggleHoldOrderPopup}
                >
                  <div className="rista-new-sprite hold-order-icon"></div>
                </div>
              }
              {!branchData?.isClosed ? (
                <div title="Notifications"
                  className={`text-18 border-l flex h-[58px] items-center justify-center hover:bg-[#EBECF1] cursor-pointer px-2 lg:px-0 lg:w-[68px] md:w-[52px] ${
                    isOffline ? "border-[#C3C3C3]" : ""
                    }`}
                  onClick={openNotifications}
                >
                  <NotificationBellIcon sx={{ fontSize: "24px" }} />
                 {!!allNewOnlineOrders?.length || unReadNotifications ? <div className="notify-number bg-[#397EF5] flex items-center justify-center h-20 px-2 rounded-sm ml-2">
                    <span className="text-15 font-inter font-semibold text-white">
                      {getUnreadNotificationNumber()}
                    </span>
                  </div> : null }
                </div>
              ) : null}
            </>
          {renderAccountandSupport()}
        </div>
        {
          isMenuOpen &&
          <Suspense fallback={<div>Loading...</div>}>
            <LeftMenu
              isMenuOpen={isMenuOpen}
              setisMenuOpen={setisMenuOpen}
              toggleMenuClick={toggleMenuClick}
              openItemStockStatus = {openItemStockStatus}
            />
          </Suspense>
        }
        {showHoldOrder ? (
          <Suspense fallback={<div>Loading...</div>}>
            <HoldOrderPopup
              isOpen={showHoldOrder}
              handleClose={toggleHoldOrderPopup}
            />
          </Suspense>
        ) : null}
        {showAccountControl && (
          <Suspense fallback={<div>Loading...</div>}>
            <AccountControl
              showModal={requestFromHeader ? false : showAccountControl}
              toggleModal={() => {
                setShowAccountControl(!showAccountControl);
                setShowChatSupportIcon?.(!showChatSupport);
              }}
              userData={userData}
              requestFromHeader= {requestFromHeader}
              removeOfflineRequest = {() => handlePropmt(false)}
            />
          </Suspense>
        )}
        {showSupportControl && (
          <Suspense fallback={<div>Loading...</div>}>
            <SupportControl
              showModal={showSupportControl}
              toggleModal={() => {
                 setShowSupportControl(!showSupportControl);
                 setShowChatSupportIcon?.(!showChatSupport);
              }}
              userData={userData}
            />
          </Suspense>
        )}
      </header>
    </>
    // </GlobalHotKeys>
  );
};

type RouteType = {
  path: string;
  name: string;
  isPermittedOffline: boolean;
  isNewFeature?: boolean;
};

const ROUTES_LIST: readonly RouteType[] = [
  { path: ROUTE_CONSTANTS_MAP.MY_ORDER_ROUTE, name: "My Orders", isPermittedOffline: true },
  { path: ROUTE_CONSTANTS_MAP.NEW_ORDER_ROUTE, name: "Take New Order", isPermittedOffline: true },
  { path: ROUTE_CONSTANTS_MAP.TABLE_VIEW_ROUTE, name: "Table View", isPermittedOffline: true },
  // { path: ROUTE_CONSTANTS_MAP.RESERVATIONS_ROUTE, name: "Reservations", isPermittedOffline: false, isNewFeature: true },
];

const RenderRoutes: React.FC<{ handleNavigate: (path: string) => void }> = ({ handleNavigate }) => {
  const { pathname } = useLocation();
  const isOffline = useSelector((state: any) => state.businessStore.isOffline);
  const isMasterConnected = useSelector((state: any) => state.globalStore.isMasterConnected)
  const showLsNotReachablePopup = isSlave() && !(isMasterConnected || pathname === ROUTE_CONSTANTS_MAP.TABLE_VIEW_ROUTE);

  function handlePath(path: string) {
    if (path === ROUTE_CONSTANTS_MAP.MY_ORDER_ROUTE)
      stopDesktopNotification();
    handleNavigate(path);
  }

  return <div className="flex">{ROUTES_LIST.map(route =>
    (route.isPermittedOffline || !isOffline) ? <a
      className={`font-inter pt-14 text-15 uppercase whitespace-nowrap cursor-pointer ${isOffline ? "text-white" : "text-black"
        } ${pathname === route.path
          ? `font-bold border-b-4 ${isOffline ? "border-white" : "border-black"
          } border-solid pb-12`
          : "pb-17 hover:bg-greyEBECF1"
        } ${showLsNotReachablePopup ? "pointer-events-none opacity-50" : ""}
          sm:p-8 md:px-8 lg:px-12 flex items-center`}
      onClick={handlePath.bind(null, route.path)}
    >
      {route.name}
      {
        route.isNewFeature &&
        <CommonChip />
      }
    </a>: null)}</div>
}

export default Header;
